import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import 'hammerjs';

import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/fr/all';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';

import { UserService } from './services/user.service';
import { AuthGuard } from './services/guard';
import { PatientService } from './services/patient.service';
import { ExpertService } from './services/admin/expert.service';
import { OrgCollectionService } from './services/org-location-collection.service';
import { RelevantLabService } from './services/relevant-lab.service';
import { DoctorService } from './services/admin/doctor.service';
import { SpecialtiesCollectionService } from './services/specialties-collection.service';
import { EmailNotificationService } from './services/notification.service';
import { LogService } from './services/logging.service';
import { OnCallScheduleCollectionService } from './services/on-call-schedule.service';
import { ProfileService } from './services/admin/profile.service';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { ListViewModule } from "@progress/kendo-angular-listview";
import { LoginComponent } from './components/login/login.component';
import { RelevantLabDocumentComponent } from './components/relevant-lab-document/relevant-lab-document.component';
import { RelevantLabComponent } from './components/relevant-lab/relevant-lab.component';
import { environment } from 'src/environments/environment.prod';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AppointmentComponent } from './components/appointment/appointment.component';
import { AppointmentCollectionService } from './services/admin/appointment-collection.service';
import { RedirectComponent } from './components/redirect/redirect.component';
import { HospitalService } from './services/hospital/hospital.service';


@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        AppointmentComponent,
        LoginComponent,
        RelevantLabComponent,
        RelevantLabDocumentComponent,
        RedirectComponent,

    ],
    imports: [
        BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        PDFModule,
        ExcelModule,
        LabelModule,
        LayoutModule,
        SchedulerModule,
        ButtonsModule,
        EditorModule,
        FileSelectModule,
        HttpClientModule,
        ChartsModule,
        IntlModule,
        DateInputsModule,
        InputsModule,
        DropDownsModule,
        NotificationModule,
        DialogModule,
        AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireFunctionsModule,
        AngularFireStorageModule,
    ],
    providers: [
        UserService,
        AuthGuard,
        AppointmentCollectionService,
        PatientService,
        ExpertService,
        OrgCollectionService,
        RelevantLabService,
        DoctorService,
        SpecialtiesCollectionService,
        EmailNotificationService,
        LogService,
        OnCallScheduleCollectionService,
        ProfileService,
        HospitalService,
        { provide: LOCALE_ID, useValue: 'en-US' }
    ],
    schemas: [
        NO_ERRORS_SCHEMA,
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [AppComponent],

})
export class AppModule { }
